import MainRoutes from './MainRoutes';
import UserRoutes from './UserRoutes';
import SecurityRoutes from './SecurityRoutes';

export const routes = [SecurityRoutes, MainRoutes, UserRoutes];